<template>
  <el-select
    :value="value"
    size="small"
    filterable
    clearable
    :collapse-tags="collapseTags"
    :loading="loading"
    @change="handleChange"
    placeholder="可多选"
    style="width: 100%"
    multiple
    :popper-append-to-body="false"
    no-data-text="暂无可选数据，请先添加配件分类"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { itemTemplateList } from '@/service/getData'

export default {
  props: {
    value: {
      type: Array,
      value: [],
    },
    category: {
      type: Number,
      default: 0,
    },
    productTemplateId: {
      type: Number,
      default: 0,
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData() {
      this.loading = true
      let data = {
        category: this.category,
        product_template_id: this.productTemplateId,
        order_sort: true,
        size: 200,
      }

      let res = await itemTemplateList(data)
      this.loading = false
      this.lists = res.data.list
    },
  },
}
</script>